module.exports = __webpack_public_path__ + "asset/img/left.53597aba.png";